<template>
    <b-modal v-model="localShow" centered hide-footer hide-header>
        <b-row class="pt-2 pb-1" align-h="center">
            <p class="title">
                {{ $t('moodPulse.deleteModal.assurance') }}
            </p>
        </b-row>
        <b-row class="pb-2 pt-3" align-h="center">
            <b-button
                style="
                    width: 100px;
                    height: 50px;
                    font-weight: bold;
                    font-size: 20px;
                "
                @click="deleteQuiz()"
                class="mr-3 small-btn"
                variant="primary"
            >
                {{ $t('moodPulse.deleteModal.yes') }}
            </b-button>
            <b-button
                style="
                    width: 100px;
                    height: 50px;
                    font-weight: bold;
                    font-size: 20px;
                "
                @click="show = false"
                variant="outline-primary"
                class="ml-2 small-btn"
            >
                {{ $t('moodPulse.deleteModal.no') }}
            </b-button>
        </b-row>
    </b-modal>
</template>

<script>
import { deleteQuiz } from '../api'
import notification, { success } from '@/lib/notification'

notification.init()

export default {
    name: 'DeleteQuestionModal',
    props: {
        show: {
            required: true,
            type: Boolean,
        },
        itemToEdit: {
            required: false,
            type: Object,
        },
    },
    watch: {
        show(a) {
            console.log(a)
        },
    },
    computed: {
        localShow: {
            get() {
                return this.show
            },
            set(localShow) {
                this.$emit('click', localShow)
            },
        },
    },
    methods: {
        deleteQuiz() {
            console.log('delete', this.itemToEdit.id)
            deleteQuiz(this.itemToEdit.id)
                .then(() => success(this.$t('moodPulse.modal.delete')))
                .catch(() => console.log(this.itemToEdit.id))
                .finally(() => {
                    this.$router.go(0)
                })
        },
    },
    data() {
        return {}
    },
}
</script>

<style scoped>
.title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color: #022b4f;
}

.label-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #808080;
}

.close {
    width: 14px;
    height: 14px;
    cursor: pointer;
}

.placeholder-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #808080;
}
</style>
